import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import Action from "../actions/modulesAction";

const initialState = {
  modules: [],
};

// function modulesReducer(state = initialState, action) {
//   switch (action.type) {
//     case Action.SET_MODULES_LIST:
//       return {
//         ...state,
//         modules: action.payloads,
//       };
//     default:
//         console.log("asdasdasd",action.payloads);
//       return state;
//   }
// }

const modulesReducer = persistReducer(
  {
    storage,
    key: "modules",
    whitelist: ["modules"],
  },
  (state = initialState, action) => {
    switch (action.type) {
      case Action.SET_MODULES_LIST:
        return {
          ...state,
          modules: action.payloads,
        };
      default:
        return state;
    }
  }
);

export default modulesReducer;
